import { getOAuthErrorMessage } from '@/libs/oauth-utils';
import { ErrorCode } from '@fluenceur/types';

/** An error shown on the auth page, with the code it came from when there is one. */
export type AuthError = { message: string; code: string | null };

/**
 * Codes saying the address belongs to a creator (or affiliate) account: the
 * sign-up API's and the Google callback's. The page points such an address to
 * the creator space.
 */
const CREATOR_ACCOUNT_CODES = new Set<string>([
  ErrorCode.E_EMAIL_CREATOR_ACCOUNT,
  ErrorCode.E_EMAIL_AFFILIATE_ACCOUNT,
  'email_is_creator',
  'email_is_affiliate',
]);

export const isCreatorAccountError = (code: string | null | undefined): boolean =>
  !!code && CREATOR_ACCOUNT_CODES.has(code);

export const isWorkEmailRequiredError = (code: string | null | undefined): boolean =>
  code === ErrorCode.E_BRAND_SIGNUP_WORK_EMAIL_REQUIRED || code === 'work_email_required';

/** The `error` a Google callback came back with, as an `AuthError`. */
export const oauthAuthError = (code: string | null): AuthError | null =>
  code ? { message: getOAuthErrorMessage(code), code } : null;
